import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractComponent } from '@shared/common/abstract.component';

import { makeProvider } from '@shared/form-fields/make-provider';
import { CONDITION_VALUE_OPTIONS, ConditionValue, Rule } from '@shared/modules/fixed-rates/fixed-rate';
import { clone } from '@shared/utils';
import { equals } from '@shared/utils/helpers';

@Component({
    selector: 'app-contract-rule',
    templateUrl: './contract-rule.component.html',
    styleUrls: ['./contract-rule.component.scss'],
    providers: [makeProvider(ContractRuleComponent)],
})
export class ContractRuleComponent extends AbstractComponent {
    private _rule: Rule;
    _ruleModel: Rule;
    conditionValueOptions = [...CONDITION_VALUE_OPTIONS];
    conditionValue = ConditionValue;

    @Input() set rule(value: Rule) {
        this._rule = value;
        this._ruleModel = clone(value);
    }

    @Output() ruleChange = new EventEmitter<Rule>();
    @Output() remove = new EventEmitter();
    @Input() disabled = false;

    addAction() {
        this._ruleModel.actions = this._ruleModel.actions ?? [];

        this._ruleModel.actions.push({
            operator: null,
            source: null,
            value: null,
            value_options: {}
        });

        this._onModelChanged();
    }

    addCondition() {
        this._ruleModel.conditions = this._ruleModel.conditions ?? [];

        this._ruleModel.conditions.push({
            operator: null,
            source: null,
            value: null,
            value_options: {}
        });

        this._onModelChanged();
    }

    removeAction(action) {
        const actions = this._ruleModel?.actions ?? [];

        actions.splice(actions.indexOf(action), 1);

        this._onModelChanged();
    }

    removeCondition(condition) {
        const conditions = this._ruleModel?.conditions ?? [];

        conditions.splice(conditions.indexOf(condition), 1);

        this._onModelChanged();
    }

    _onModelChanged() {
        const hasChanged = !equals(this._rule, this._ruleModel);

        this._ruleModel.conditions.map(condition => {
            if (condition.value !== ConditionValue.specialDay) {
                condition.value_options = {};
            }

            return condition;
        });

        if (hasChanged) {
            this.ruleChange.emit(this._ruleModel);
        }
    }
}
